module.exports = __webpack_public_path__ + "static/media/attend.c33b067a.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/attend.gif
// module id = 202
// module chunks = 0